function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 22.1c5.6 0 10.1-4.5 10.1-10.1S17.6 1.9 12 1.9 1.9 6.4 1.9 12 6.4 22.1 12 22.1zm0 1.9C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.9,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 8.9,
  r: 1.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 19.4c-5.2 0-7.3-4.9-7.4-5.1-.2-.4 0-.9.4-1.1.4-.2.9 0 1.1.4.1.2 1.8 4 5.9 4 4.1 0 5.8-4 5.9-4 .2-.4.7-.6 1.1-.4.4.2.6.7.4 1.1-.1.3-2.2 5.1-7.4 5.1z",
  fillRule: "nonzero"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;